<script lang="ts">
  /**
   * OverlayContainer — modal overlay system.
   *
   * Renders the correct overlay based on `activeOverlay` value.
   * Same key toggles open/closed. ESC also closes.
   */
  import type { OverlayKind } from "$lib/stores/game.svelte";
  import MapOverlay from "./MapOverlay.svelte";
  import TimelineOverlay from "./TimelineOverlay.svelte";
  import RelationshipsOverlay from "./RelationshipsOverlay.svelte";
  import JournalOverlay from "./JournalOverlay.svelte";
  import SettingsOverlay from "./SettingsOverlay.svelte";

  interface Props {
    activeOverlay: OverlayKind | null;
    onClose: () => void;
  }

  let { activeOverlay, onClose }: Props = $props();

  function handleKeydown(e: KeyboardEvent): void {
    if (activeOverlay === null) return;
    if (e.key === "Escape") {
      e.preventDefault();
      onClose();
    }
  }

  function handleBackdropClick(): void {
    onClose();
  }
</script>

<svelte:window onkeydown={handleKeydown} />

{#if activeOverlay !== null}
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <div class="overlay-backdrop" onclick={handleBackdropClick}>
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="overlay-panel" onclick={(e) => e.stopPropagation()}>
      {#if activeOverlay === "map"}
        <MapOverlay />
      {:else if activeOverlay === "timeline"}
        <TimelineOverlay />
      {:else if activeOverlay === "relationships"}
        <RelationshipsOverlay />
      {:else if activeOverlay === "journal"}
        <JournalOverlay />
      {:else if activeOverlay === "settings"}
        <SettingsOverlay />
      {/if}

      <button class="overlay-close" onclick={onClose}>[ESC to close]</button>
    </div>
  </div>
{/if}

<style>
  .overlay-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .overlay-panel {
    background: var(--bg);
    border: 1px solid var(--fg-dim);
    max-width: 90vw;
    max-height: 85vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .overlay-close {
    background: none;
    border: none;
    color: var(--fg-dim);
    font-family: var(--font-mono);
    font-size: 0.75rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    margin-top: 0.25rem;
  }

  .overlay-close:hover {
    color: var(--fg);
  }
</style>
